import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Button, Alert, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import AdminLayout from '../../components/admin/AdminLayout';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

function CategoryManagementPage() {
    const { token } = useAuth();
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [newCategory, setNewCategory] = useState('');

    const fetchCategories = async () => {
        setLoading(true);
        try {
            const { data } = await axios.get('/api/admin/categories', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setCategories(data);
        } catch (err) {
            setError('Failed to fetch categories.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, [token]);

    const handleAddCategory = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await axios.post('/api/admin/categories', { name: newCategory }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setNewCategory('');
            fetchCategories();
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to add category.');
        }
    };

    const handleDeleteCategory = async (id) => {
        if (window.confirm("Are you sure you want to delete this category?")) {
            try {
                await axios.delete(`/api/admin/categories/${id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                fetchCategories();
            } catch (err) {
                setError('Failed to delete category.');
            }
        }
    };

    return (
        <AdminLayout>
            <Typography variant="h4" gutterBottom>Category Management</Typography>
            <Box component="form" onSubmit={handleAddCategory} sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <TextField label="New Category Name" value={newCategory} onChange={(e) => setNewCategory(e.target.value)} size="small" />
                <Button type="submit" variant="contained">Add</Button>
            </Box>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {loading ? <CircularProgress /> : (
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Category Name</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {categories.map((cat) => (
                                <TableRow key={cat._id}>
                                    <TableCell>{cat.name}</TableCell>
                                    <TableCell>
                                        <Button color="error" onClick={() => handleDeleteCategory(cat._id)}>Delete</Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </AdminLayout>
    );
}

export default CategoryManagementPage;